var React = require('react');

function Blob (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_2","data-name":"Path 2","d":"M3328.3,15.816s211.568-8.541,254.288,126.442-413.7,299.382-235.814,405.184S3489.342,888.1,3632.735,955.393s474.056-202.08,564.886-96.7,284.428,37.268,284.428,37.268V15.816Z","transform":"translate(-3305.432 -15.708)","fill":"#c0d4f6"}));
}

Blob.defaultProps = {"width":"1176.617","height":"950.628","viewBox":"0 0 1176.617 950.628","preserveAspectRatio":"xMidYMid"};

module.exports = Blob;

Blob.default = Blob;
